export default __webpack_public_path__ + "static/media/4.d715b32b.webp";